import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DialogRef } from '@angular/cdk/dialog';
import { ButtonGroupModule } from '@libs/ui-lib';
import { PushTagOnClickDirective, TagEvent } from '@libs/shared-services';

@Component({
  selector: 'lib-unsend-message-confirm-dialog',
  imports: [CommonModule, TranslateModule, ButtonGroupModule, PushTagOnClickDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './unsend-message-confirm-dialog.component.html',
  styleUrl: './unsend-message-confirm-dialog.component.scss',
})
export class UnsendMessageConfirmDialogComponent {
  private readonly dialogRef = inject(DialogRef);

  protected readonly TagEvent = TagEvent;

  public closeDialog(confirm: boolean = false): void {
    this.dialogRef.close(confirm);
  }
}
